<template>
    <div class="phone-alert-affirm">
        <div class="box">
            <i class="el-icon-close" @click="$emit('close')"></i>
            <div class="title" slot="title">
                <slot name="title"></slot>
            </div>
            <div class="content">
                <slot name="content"></slot>
            </div>
            <div class="footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PhoneAffirm",
        data(){
            return {
                affirmData:''
            }
        },
        props:{
            data:[Object],
            title:[String]
        },
        created() {
            try{
                this.affirmData = JSON.parse(JSON.stringify(this.data))
            }catch (e) {

            }
        },
        methods:{
            affirm(){

            },
            cancel(){

            }
        }
    }
</script>

<style scoped lang="scss">

    //手机端Affirm公共样式
    .phone-alert-affirm {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background: rgba(0, 0, 0, 0.3);


        > div.box {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
            padding: 30px 20px;
            box-sizing: border-box;
            background: #ffffff;

            > i.el-icon-close {
                position: absolute;
                padding: 6px;
                right: 0;
                top: 0;
                cursor: pointer;
                transition: opacity 0.3s linear;

                &:hover {
                    color: #F44336;
                    transition: opacity 0.3s linear;
                }
            }

            > .footer {
                display: flex;
                flex-direction: column;

                > span {
                    width: 100%;
                    height: 32px;
                    background: #089bab;
                    text-align: center;
                    line-height: 32px;
                    color: #ffffff;
                    cursor: pointer;
                    border-radius: 4px;
                    transition: background 0.3s linear;
                    font-size: 14px;

                    &:hover {
                        background: #068896;
                        transition: background 0.3s linear;
                    }
                }
            }
        }
    }
</style>
